import { render } from "./NcrmIconGridPicker.vue?vue&type=template&id=60b8717b&scoped=true"
import script from "./NcrmIconGridPicker.vue?vue&type=script&lang=js"
export * from "./NcrmIconGridPicker.vue?vue&type=script&lang=js"

import "./NcrmIconGridPicker.vue?vue&type=style&index=0&id=60b8717b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b8717b"]])

export default __exports__